export default {"src":"/_next/static/media/diploma-hero.18d053c2.svg","height":240,"width":366,"blurWidth":0,"blurHeight":0};